<template>
  <v-row align="center" justify="center">
    <v-col sm="4">
      <v-card :loading="loading" :disabled="loading">
        <v-card-title>Edit prizes</v-card-title>
        <v-card-text>
          <validation-observer
            ref="validationObserver"
            v-slot="{ handleSubmit }"
            slim>
            <v-form @submit.prevent="handleSubmit(savePrizes)">
              <validation-provider
                v-for="(prize, index) in prizes"
                :key="prize.prizeCategory.id"
                :name="`prizes[${index}].amount`"
                v-slot="{ errors }">
                <v-text-field
                  :label="prize.prizeCategory.name"
                  v-model.number="prizes[index].amount"
                  persistent-hint
                  :name="`prizes[${index}].amount`"
                  :hint="`Last update: ${prize.updatedAt || 'Never'}`"
                  :error-messages="errors"
                  type="number">
                  <template #prepend-inner>
                    <font-awesome-icon icon="dollar-sign"></font-awesome-icon>
                  </template>
                </v-text-field>
              </validation-provider>
              <input type="submit" hidden />
            </v-form>
          </validation-observer>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="savePrizes" color="primary">
            Update prizes
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { fetchPrizes, updatePrizes } from "../../../../api/prize.api.js";
import ContentLoader from "../../../mixins/ContentLoader.js";
import keyBy from "lodash/keyBy";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Validatable from "../../../mixins/Validatable.js";

function mapPrizeToServerSideInformation({ prizeCategory, amount }) {
  return {
    prizeCategoryId: prizeCategory.id,
    amount
  };
}

export default {
  name: "PrizeEdit",
  mixins: [ContentLoader, Validatable],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      prizes: []
    };
  },
  async created() {
    this.$startLoading();
    try {
      const { data } = await fetchPrizes();

      this.prizes = data.prizes;
    } catch (e) {
      console.error(e);
    } finally {
      this.$finishedLoading();
    }
  },
  methods: {
    async savePrizes() {
      this.$startLoading();
      const form = {
        prizes: this.prizes.map(mapPrizeToServerSideInformation)
      };

      try {
        const { data } = await updatePrizes(form),
          prizeCategoryToPrize = keyBy(this.prizes, "prizeCategory.id");

        data?.prizes?.forEach(prize => {
          this.$set(
            prizeCategoryToPrize[prize.prizeCategoryId],
            "updatedAt",
            prize.updatedAt
          );
        });
      } catch (e) {
        this.handleErrorResponse(this.$refs.validationObserver, e);
      } finally {
        this.$finishedLoading();
      }
    }
  }
};
</script>
